<template>
  <div id="GameList">
    <ul>
      <li v-for="(it, i) in allGame" :key="i" v-if="!noGame.includes(it.gameType)">
        <!-- <img :src="it.imgUrl" alt> -->
        <div class="avatar">
          <div class="avatarInside">
            <img v-lazy="{ src: qiniuUrl + it.netImgUrl }" alt />
          </div>
        </div>
        <div class="list">
          <p class="name">{{ it.memo }}</p>
          <span v-for="(is, j) in menus[it.type]" :key="j" @click="goto(it, is.alias)">{{ is.name }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import getBetType from '../../helpers/getBetType.js';
import menus from '../../helpers/trendMenus.js';
export default {
  name: 'GameList',
  computed: {
    ...mapState(['allGame', 'qiniuUrl'])
  },
  data() {
    return {
      // noGame: ["ZKLHC", "HKLHC", "SD115", "GD115", "FC3D", "PL3", "PL5"],
      noGame: [],
      menus
    };
  },
  methods: {
    goto(it, type) {
      this.$router.push(`/Trend/${it.type}/${it.gameType}${type ? '?modeType=' + type : ''}`);
    }
  }
};
</script>
<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/GameList/index.vue